module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('article', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-info"
  }, [_vm._v("First column")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-success"
  }, [_vm._v("Second column")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-warning"
  }, [_vm._v("Third column")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "notification is-danger"
  }, [_vm._v("Fourth column")])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns is-multiline",
    attrs: {
      "id": "grid"
    }
  }, [_c('div', {
    staticClass: "column is-three-quarters"
  }, [_c('p', [_c('code', {
    staticClass: "html"
  }, [_vm._v("is-three-quarters")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Auto")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Auto")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-10 is-offset-1"
  }, [_c('p', [_c('code', [_vm._v("is-10 is-offset-1")])])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns",
    attrs: {
      "id": "offsetEx"
    }
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-half is-offset-one-quarter")])])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-8"
  }, [_c('p', [_c('code', [_vm._v("is-4 is-offset-8")])])])]), _vm._v(" "), _c('article', {
    staticClass: "example-fill columns",
    attrs: {
      "id": "multiline"
    }
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarte")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarter")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarter")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('p', [_c('code', [_vm._v("is-one-quarter")])])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-8"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child notification is-primary"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Vertical...")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("Top tile")])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child notification is-warning"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("...tiles")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("Bottom tile")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification is-info"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Middle tile")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("With an image")]), _vm._v(" "), _c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/640x480.png"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification is-danger"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Wide tile")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("Aligned with the right tile")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child notification is-success"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "global_title"
  }, [_vm._v("Tall tile")]), _vm._v(" "), _c('p', {
    staticClass: "global_subtitle"
  }, [_vm._v("With even more content")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23fb6116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/Grid.vue
// module id = 81
// module chunks = 0